<div class="content">
  <h2 class="title">{{ 'resource_transfer.title' | translate }}</h2>

  <div class="div-line"></div>

  <div class="resource-container mt-3">
    <div class="row">
      <div class="col-6">
        <div class="resource-item" [class.item-error]="contractError">
          <div class="card-header-red">{{ 'resource_transfer.contract_doc' | translate }}</div>

          <div class="item-body">
            <p class="available-text">{{ 'resource_transfer.available_qty' | translate }}: {{ maxContractDisplay }}
            </p>

            <mat-form-field appearance="outline" class="w-100 custom-input-number">
              <input matInput #contractInput type="text" inputmode="numeric" [disabled]="isContractExpired"
                [value]="formatterNumber(contractValue)" (input)="onContractInput($event)"
                [placeholder]="'resource_transfer.place_holder' | translate"
                (compositionstart)="onCompositionStart()" (compositionend)="onContractCompositionEnd($event)" />
              <div matSuffix class="number-handlers">
                <button type="button" mat-icon-button class="handler-btn handler-up" (click)="stepContract(1)"
                  [disabled]="isContractExpired || contractValue >= maxContract">
                  <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <button type="button" mat-icon-button class="handler-btn handler-down" (click)="stepContract(-1)"
                  [disabled]="isContractExpired || contractValue <= 0">
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
              </div>
            </mat-form-field>

            <div class="error-inline" *ngIf="contractError">
              {{ contractError }}
            </div>

            <p class="remaining-text" *ngIf="!contractError && !isContractExpired">
              {{ 'resource_transfer.remaining_qty' | translate }}: {{ remainingContractDisplay }}
            </p>
            <div class="error-inline expired-inline" *ngIf="isContractExpired">
              {{ 'resource_transfer.expired_message' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="resource-item">
          <div class="card-header-red">{{ 'resource_transfer.sms_credit' | translate }}</div>
          <div class="item-body">
            <p class="available-text">{{ 'resource_transfer.available_qty' | translate }}: {{ maxSmsDisplay }}₫</p>

            <mat-form-field appearance="outline" class="w-100 custom-input-number">
              <input matInput #smsInput type="text" inputmode="numeric" [disabled]="isSmsExpired"
                [value]="formatterNumber(smsValue)" (input)="onSmsInput($event)"
                [placeholder]="'resource_transfer.place_holder' | translate"
                (compositionstart)="onCompositionStart()" (compositionend)="onSmsCompositionEnd($event)" />
              <div matSuffix class="number-handlers">
                <button type="button" mat-icon-button class="handler-btn handler-up" (click)="stepSms(1)"
                  [disabled]="isSmsExpired || smsValue >= maxSms">
                  <mat-icon>keyboard_arrow_up</mat-icon>
                </button>
                <button type="button" mat-icon-button class="handler-btn handler-down" (click)="stepSms(-1)"
                  [disabled]="isSmsExpired || smsValue <= 0">
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
              </div>
            </mat-form-field>
            <div class="error-inline" *ngIf="smsError">{{ smsError }}</div>

            <p class="remaining-text" *ngIf="!isSmsExpired">{{ 'resource_transfer.remaining_qty' | translate }}: {{ remainingSmsDisplay }}&#8363;</p>
            <div class="error-inline expired-inline" *ngIf="isSmsExpired">
              {{ 'resource_transfer.expired_message' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="impact-section mt-4">
    <span>{{ 'resource_transfer.system_impact' | translate }}</span>
    <ul>
      <li>- {{ 'resource_transfer.impact_desc_1' | translate }}</li>
      <li>- {{ 'resource_transfer.impact_desc_2' | translate }}</li>
    </ul>
  </div>

  <div class="d-flex justify-content-center mt-4">
    <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="isSubmitDisabled">
      {{ 'resource_transfer.confirm_btn' | translate }}
    </button>
  </div>
</div>